var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkyBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 39,
    viewBox: "0 0 107 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5091 38.9925C26.092 38.9925 31.4078 33.3469 31.4078 26.6557C31.4078 13.1601 12.5342 16.8194 12.5342 12.4369C12.5342 11.1824 13.607 10.1369 16.9721 10.1369C19.9471 10.1369 23.1171 11.0256 26.4822 12.8551L29.9448 3.91617C26.3846 1.77296 21.6539 0.727417 17.0697 0.727417C6.48684 0.727417 1.17102 6.26849 1.17102 13.0642C1.17102 26.708 20.0446 22.9878 20.0446 27.5965C20.0446 28.8512 18.8741 29.5831 15.6067 29.5831C11.8514 29.5831 7.55963 28.2761 4.34084 26.2375L0.634521 35.2287C4.0484 37.4765 9.80315 38.9925 15.5091 38.9925ZM59.4501 38.1561H72.7642L58.426 17.6645L72.0814 1.56386H59.5476L48.3307 14.8417V1.56386H37.0163V38.1561H48.3307V29.1126L50.9155 26.0284L59.4501 38.1561ZM107 1.56386H95.8806L88.858 14.2143L81.8839 1.56386H69.7403L82.6155 24.7214V38.1561H94.125V24.8783L107 1.56386Z",
    fill: "#1F1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyBlackLogo);
export default __webpack_public_path__ + "static/media/skyBlackLogo.70944879239761683467eeabf7dc30ca.svg";
export { ForwardRef as ReactComponent };